import { render, staticRenderFns } from "./form-create-project.vue?vue&type=template&id=c8cbef2a"
import script from "./form-create-project.vue?vue&type=script&lang=js"
export * from "./form-create-project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports